export const DEFAULT_LANGUAGE = 'en';
export const API_URL = 'https://selfservice.maxio.com/api';
const LOAD_PATH_VERSION_NUMBER = 'v1';
export const DEFAULT_LOAD_PATH = `https://embeddable-ui-components.maxio.com/translations/${LOAD_PATH_VERSION_NUMBER}/{{lng}}/{{ns}}.json`;
